// Core imports
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

// Third party imports
import { Observable } from 'rxjs';

// Application imports
import { Configuration } from '../configuration';
import { HttpService } from './http.service';
import { BASE_PATH } from '../variables';

@Injectable({
  providedIn: 'root'
})
export class HttpAuthService extends HttpService {

  constructor(
    protected httpClient: HttpClient,
    @Optional()@Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    super(httpClient, basePath, configuration);
  }

  // --- Public Methods ---

  /** Performs user login. */
  public login(body: any): Observable<any> {
    let headers = this.defaultHeaders
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json');

    return this.httpClient.post<any>(
      `${this.configuration.basePath}/api/user/login`,
      body,
      { headers }
    );
  }
}
